import debug from 'debug';

import { BaseActions } from '../Common/Actions/BaseActions';
import { execAction } from '../Common/Actions/handler';
import { ResponseEither } from '../Common/ResponseEither';
import { ISHomeBenefitBannerPayload } from './interfaces/ISHomeBenefitBannerPayload';
import { ISHomeCommonRequestParams } from './interfaces/ISHomeCommonRequestParams';
import SHomeRequestBuilder from './SHomeRequestBuilder';

const log = debug('sunny:SHomeActions');

export default class SHomeActions extends BaseActions<SHomeRequestBuilder> {
  benefitBanner(params: ISHomeCommonRequestParams): Promise<ResponseEither<ISHomeBenefitBannerPayload>> {
    log('Getting data of a benefit banner');
    return execAction('subhome benefit banner', this.requestBuilder.createGetBenefitBannerQuery(params));
  }
}
